(function($){

    $(document).ready(function () {

        // fade in main menu on page load
        $(function(){
           function show_menu(){
              $("#mainMenu").animate({opacity: '1'}, 300, 'linear');
           };
           window.setTimeout( show_menu, 250 );
        });


        // Mobile menu animations
        $('#triggerContainer').on('click', function(){

            // close menu
            if($(this).hasClass('open')){

                $(this).removeClass('open');
                $('#trigger').removeClass('open');
                $('body').removeClass('disable');
                $('html').removeClass('disable');
                $('#mainMenu').animate({right: '-100vw'}, 300, 'linear');

            // open menu
            } else {

                $('body').addClass('disable');
                $('html').addClass('disable');
                $('#mainMenu').animate({right: '0px'}, 300, 'linear');
                $('#trigger').addClass('open');
                $(this).addClass('open');

            }

        });


        // Add a <span> to every menu-item that has a <ul> inside
        $('#mainMenu .menu > li.menu-item-has-children > a').prepend('<span class="nav-click"><i class="fa-regular fa-chevron-down"></i></span>');

        // dynamic binding to on 'click'
        $('#mainMenu .menu > li.menu-item-has-children > a').on('click', '.nav-click', function(){
            event.preventDefault();
            // Toggle the nested nav
            $(this).toggleClass('opened');
            $(this).parent().next('.sub-menu').slideToggle();
        });


        // Go to top button
        $(window).scroll(function() {
            if ($(this).scrollTop() > 600){
                $('#goTop').addClass("active");
            } else {
                $('#goTop').removeClass("active");
            }
        });


        // Scroll on click
        $(document).on('click', 'a.skip-link', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 1000);
        });


        // Remove empty paragraphs
        $('p:empty:not([role])').remove();


        // Remove p tags around images when using the WYSIWYG advanced custom field
        $('p > img').unwrap();


        // Fancybox
        Fancybox.bind('[data-fancybox="gallery"]', {
            Images: {
                protected: true
            },
        }); 

    });

})(jQuery);


gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function(event) {
    window.addEventListener(
        'load',
        function(e) {

            gsap.set(".timeline-entry__info", {
                y: 75,
                opacity: 0
            });
            ScrollTrigger.batch(".timeline-entry__info", {
                onEnter: batch => gsap.to(batch, {
                    duration: 0.9,
                    ease: 'circ',
                    autoAlpha: 1,
                    y: 0,
                })
            });

            gsap.set(".timeline-entry__line", {
                transformOrigin:"100% 50%",
                width:"0px"
            });
            ScrollTrigger.batch(".timeline-entry__line", {
                onEnter: batch => gsap.to(batch, {
                    duration: 1.25,
                    ease: 'power3',
                    width:"45px",
                    delay: 0.3,
                    stagger: {
                        each: 0.2,
                        grid: [1, 6]
                    },
                    overwrite: true
                })
            });

        },
        false
    );
});